import type { StateStore } from '@playcastdotio/CoreTypes';
import { useEffect, useState } from 'react';

export const useStoreListener = <T>(stateStore: StateStore<any>) => {
  const [state, setState] = useState(stateStore.currentState);

  useEffect(() => {
    const handleStateChange = (newState) => {
      setState(newState);
    };

    const listenerId = stateStore.addListener(handleStateChange);

    return () => {
      stateStore.removeListener(listenerId);
    };
  }, [stateStore]);

  return state as T;
};
